import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      minWidth: 0,
      minHeight: 0,
      display: 'grid',
      gap: theme.spacing(0.25),

      '&[data-image-count="1"]': {
        gridTemplateColumns: '1fr',
        gridTemplateRows: '1fr',

        '& $image': {
          width: '100%',
          height: '100%',
        },
      },

      '&[data-image-count="2"]': {
        gridTemplateColumns: '1fr',
        gridTemplateRows: '1fr 1fr',

        '& $image': {
          width: '100%',
        },
      },

      '&[data-image-count="3"]': {
        gridTemplateColumns: '1fr 1fr',
        gridTemplateRows: '1fr 1fr',

        '& $image:first-child': {
          width: '100%',
          gridColumn: 'span 2',
        },
      },

      '&[data-image-count="4"]': {
        gridTemplateColumns: '1fr 1fr',
        gridTemplateRows: '1fr 1fr',
      },
    },
    image: {
      minWidth: 0,
      minHeight: 0,
      overflow: 'hidden',
      // width: 60,
      // height: 60,
      borderRadius: theme.shape.borderRadiusSmall,
    },
  }),
  { name: 'ImageStyleCard' }
);
